import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Divider,
  Breadcrumb,
  Upload,
  Input,
  Spin,
  Image,
  Modal,
  Select,
} from "antd";
import Main from "../../components/layout/Main";
import RepliesImage from "../../assets/images/replies-chat.svg";
import EyeIcon from "../../assets/images/views-eye.svg";
import { useParams, useNavigate } from "react-router";
import LiveStreamCarousel from "../../components/forsliders";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import UpIconImage from "../../assets/images/up-topics-icon.svg";
import ArrowUp from "../../assets/images/arrow-up.svg";
import ArrowDownImg from "../../assets/images/arrow-down.svg";
import DownIconImage from "../../assets/images/low-topics-icon.svg";
import QuoteIconImage from "../../assets/images/quote-icon.svg";
import ReportIconImage from "../../assets/images/report-icon.svg";
import UserImage from "../../assets/images/user.png";
import LinkOutImage from "../../assets/images/link_main_commentss.svg";
import { useForums } from "../../context/ForumsContext";
import CommonBreadcrumb from "../../components/BreadCrumb";
import { ShowToast, Severty } from "../../helper/toast";
import ReportModal from "../../components/ReportModal";
const { TextArea } = Input;
const { Option } = Select;

const FinalRoundNews = () => {
  const { id } = useParams();
  const {
    getThreadDetails,
    replyOnThread,
    getForums,
    replyOnComment,
    submitVote,
    createThread,
    reportForum,
  } = useForums();
  const navigate = useNavigate();
  const [reportOpen, setReportOpen] = useState(false);
  const [commentId, setCommentId] = useState(null);
  const bottomReplyRef = useRef(null);
  const [thread, setThread] = useState(null);
  const [loading, setLoading] = useState(true);
  const [visibleReplies, setVisibleReplies] = useState({});
  const [replyContent, setReplyContent] = useState("");
  const [replyFiles, setReplyFiles] = useState([]);
  const [activeReplyTo, setActiveReplyTo] = useState(null);
  const [replyContents, setReplyContents] = useState({});
  const [replyFilesMap, setReplyFilesMap] = useState({});
  const [fileError, setFileError] = useState(null);
  const [fileCommentError, setFileCommentError] = useState(null);
  const [isForumModalVisible, setIsForumModalVisible] = useState(false);
  const [isTopicModalVisible, setIsTopicModalVisible] = useState(false);
  const [forums, setForums] = useState([]);
  const [selectedForum, setSelectedForum] = useState(null);
  const [topicTitle, setTopicTitle] = useState("");
  const [topicDescription, setTopicDescription] = useState("");
  const [files, setFiles] = useState([]);

  const scrollToBottomReply = () => {
    if (bottomReplyRef.current) {
      bottomReplyRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      // focus the textarea inside the bottom reply box
      const textarea = bottomReplyRef.current.querySelector("textarea");
      if (textarea) textarea.focus();
    }
  };

  useEffect(() => {
    const fetchThread = async () => {
      try {
        setLoading(true);
        const res = await getThreadDetails(id);
        if (res.success && res.data) {
          setThread(res.data);
        }
      } catch (error) {
        console.error("Failed to fetch thread details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchThread();
  }, [id]);

  const toggleReplies = (commentId) => {
    setVisibleReplies((prev) => ({
      ...prev,
      [commentId]: !prev[commentId],
    }));
  };

  const submitReply = async ({ type, id, content, files }) => {
    if (!content?.trim()) {
      ShowToast("Reply content cannot be empty", Severty.ERROR);
      return;
    }

    const formData = new FormData();
    formData.append("content", content);
    (files || []).forEach((file) => formData.append("files", file));

    let res;
    if (type === "comment") {
      if (fileCommentError) {
        return;
      }
      res = await replyOnComment(thread.threadId, id, formData);
    } else if (type === "thread") {
      if (fileError) {
        return;
      }
      res = await replyOnThread(thread.threadId, formData);
    }

    if (res?.success) {
      const updatedThread = await getThreadDetails(thread.threadId);
      setThread(updatedThread.data);
      // clear only this reply box
      if (type === "comment") {
        setReplyContents((prev) => ({ ...prev, [id]: "" }));
        setReplyFilesMap((prev) => ({ ...prev, [id]: [] }));
      } else {
        setReplyContent("");
        setReplyFiles([]);
      }
      setActiveReplyTo(null);
    } else {
      ShowToast("Failed to submit reply", Severty.ERROR);
    }
  };

  const vote = async ({ threadId, commentId, action }) => {
    try {
      const res = await submitVote(threadId, commentId, action);
      if (res.status === 200) {
        ShowToast(res.message, Severty.SUCCESS);
        const updatedThread = await getThreadDetails(threadId);
        setThread(updatedThread.data);
      } else {
        ShowToast("Failed to submit vote", Severty.ERROR);
      }
    } catch (err) {
      console.error("Vote error:", err);
      ShowToast("Failed to submit vote", Severty.ERROR);
    }
  };

  const showForumModal = async () => {
    setIsForumModalVisible(true);
    try {
      const res = await getForums();
      if (res.success && res.data.data) {
        setForums(res.data.data);
      }
    } catch (error) {
      console.error("Failed to load forums:", error);
    }
  };

  const handleForumContinue = () => {
    if (!selectedForum) return;
    setIsForumModalVisible(false);
    setIsTopicModalVisible(true);
  };

  const handleTopicSubmit = async () => {
    if (!selectedForum) {
      console.error("No forum selected");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("title", topicTitle);
      formData.append("content", topicDescription);
      formData.append("forumId", selectedForum);
      files.forEach((file) => formData.append("files", file));

      const res = await createThread(formData);
      if (res.success) {
        setIsTopicModalVisible(false);
        setTopicTitle("");
        setTopicDescription("");
      }
    } catch (error) {
      console.error("Failed to create thread:", error);
    }
  };

  if (loading) {
    return (
      <Main>
        <div style={{ textAlign: "center", padding: "100px 0" }}>
          <Spin size="large" tip="Loading thread details..." />
        </div>
      </Main>
    );
  }

  if (!thread) {
    return (
      <Main>
        <div style={{ textAlign: "center", padding: "50px 0" }}>
          <h3>Thread not found</h3>
          <Button onClick={() => navigate(-1)}>Go Back</Button>
        </div>
      </Main>
    );
  }

  return (
    <Main>
      <div className="section-main">
        <CommonBreadcrumb
          items={[
            { title: "Home", url: "/home" },
            { title: "Forums & Community", url: "/forums" },
            { title: "Up-Coming Events" },
            { title: thread.threadName },
          ]}
        />
        <h3 className="event-header-main">{thread.threadName}</h3>

        {/* Views and Replies */}
        <div className="views-and-replyies">
          <h4>
            <img src={EyeIcon} alt="views" /> {thread.totalViews} Views
          </h4>
          <h4>
            <img src={RepliesImage} alt="replies" /> {thread.totalComments}{" "}
            Replies
          </h4>
        </div>

        {/* Thread Media */}
        {/* {thread.mediaFiles?.length > 0 && (
          <div className="thread-media">
            {thread.mediaFiles.map((file, idx) => (
              <img
                key={idx}
                src={file}
                alt="thread media"
                style={{ maxWidth: 50, marginRight: 8, borderRadius: 6 }}
              />
            ))}
          </div>
        )} */}

        <LiveStreamCarousel />

        <div className="section-space-button-ctc">
          <Button className="main-border-button" onClick={showForumModal}>
            Start a new topic
          </Button>
          <Button
            className="main-fill-button"
            onClick={() => {
              setActiveReplyTo({ type: "thread", id: thread.threadId });
              scrollToBottomReply(); // ✅ scroll to bottom reply
            }}
          >
            Reply to this topic
          </Button>
        </div>

        {/* Comments */}
        {thread.comments?.map((comment, index) => {
          console.log("comment ---->", comment);
          return (
            <div key={index} className="topics-main-grid">
              <div className="news-man-profile">
                <img src={comment.user.profilePic || UserImage} alt="user" />
                <h2>{comment.user.name}</h2>
                {comment.user.username && <h6>@{comment.user.username}</h6>}
                {}
                <p>Member: {comment.user.userId}</p>
                <p>Joined:{comment.user.joinedAt}</p>
                <p>{comment.user.lastVisit}</p>
              </div>

              <div style={{ flex: 1 }} className="news-main-second-card">
                <div className="time-main-classh-poasted">
                  {comment.timeAgo}
                </div>
                <div className="comments-video-main">
                  <div className="comments-main-text">
                    <h4>{comment.content}</h4>
                  </div>
                  {/* Comment Media */}
                  {comment.mediaFiles?.length > 0 && (
                    <div className="comment-media">
                      {comment.mediaFiles.map((file, idx) => (
                        <Image key={idx} src={file} alt="comment media" />
                      ))}
                    </div>
                  )}
                </div>
                <Divider className="news-section-devider" />
                {/* Reply / Votes */}
                <div style={{ textAlign: "right", marginTop: 12 }}>
                  <div className="shanre-button-news">
                    <div className="topics-card-footer-leftbar">
                      <div className="topicstop-bar">
                        {/* UPVOTE */}
                        <img
                          src={
                            comment?.votes?.youVoted === "up"
                              ? UpIconImage
                              : ArrowUp
                          }
                          alt="upvote"
                          onClick={() =>
                            vote({
                              threadId: thread.threadId,
                              commentId: comment.commentId,
                              action: "up",
                            })
                          }
                          style={{ cursor: "pointer" }}
                        />

                        <span>{comment?.votes?.up || 0}</span>

                        {/* DOWNVOTE */}
                        <img
                          src={
                            comment?.votes?.youVoted === "down"
                              ? DownIconImage
                              : ArrowDownImg
                          }
                          alt="downvote"
                          onClick={() =>
                            vote({
                              threadId: thread.threadId,
                              commentId: comment.commentId,
                              action: "down",
                            })
                          }
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      {/* {comment.replies?.length > 0 && ( */}
                      <div
                        className="topicstop-bar-replay"
                        onClick={() => {
                          toggleReplies(comment.commentId); // ✅ toggle visibility
                          setActiveReplyTo({
                            type: "comment",
                            id: comment.commentId,
                          }); // set active reply target
                        }}
                      >
                        <img src={QuoteIconImage} alt="reply" />
                        {visibleReplies[comment.commentId]
                          ? "Hide Replies"
                          : `Reply (${comment.replies.length})`}
                      </div>
                      {/* )} */}
                    </div>
                    <div
                      className="report-topics"
                      onClick={() => {
                        setReportOpen(true);
                        setCommentId(thread.threadId); //If needed comment than change it
                      }}
                    >
                      <img src={ReportIconImage} alt="report" /> Report
                    </div>
                  </div>
                  {visibleReplies[comment.commentId] && (
                    <>
                      {/* Replies loop */}
                      {comment.replies?.map((reply) => (
                        <div key={reply.replyId}>
                          <Divider className="news-section-devider" />
                          <div className="main_comment_inner-section">
                            <div className="news-man-profile">
                              <img
                                src={reply.user.profilePic || UserImage}
                                alt="reply-user"
                              />
                              <h2>{reply.user.name}</h2>
                              {reply.user.username && (
                                <h6>
                                  <span>@{reply.user.username}</span>
                                </h6>
                              )}
                              <p>{reply.timeAgo}</p>
                            </div>
                            <div className="comment-section_main">
                              <div className="comments-video-main">
                                <div className="comments-main-text">
                                  <p>{reply.content}</p>
                                </div>
                                <div className="comment-media">
                                  {reply.mediaFiles?.map((file, idx) => (
                                    <Image
                                      key={idx}
                                      src={file}
                                      alt="reply media"
                                      style={{
                                        maxWidth: 50,
                                        marginRight: 4,
                                        borderRadius: 6,
                                      }}
                                    />
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}

                      <div
                        style={{ flex: 1 }}
                        className="news-main-second-card mt-3"
                      >
                        <div className="upload-button-topics">
                          <TextArea
                            placeholder="Write your reply..."
                            rows={4}
                            value={replyContents[comment.commentId] || ""}
                            onChange={(e) =>
                              setReplyContents((prev) => ({
                                ...prev,
                                [comment.commentId]: e.target.value,
                              }))
                            }
                          />
                          <div className="custom-upload-menu_top">
                            <img src={LinkOutImage} />
                            <div className="custom-upload-menu">
                              <span>
                                Drag files here to attach, or
                                <Upload
                                  className="multipal-image"
                                  beforeUpload={(file) => {
                                    const allowedTypes = [
                                      "image/jpeg",
                                      "image/jpg",
                                      "image/png",
                                      "image/webp",
                                      "application/pdf",
                                    ];

                                    // Check file type
                                    const isAllowed = allowedTypes.includes(
                                      file.type
                                    );

                                    if (!isAllowed) {
                                      // ❌ Show inline Ant Design error
                                      setFileCommentError(
                                        "Invalid file type! Only JPG, JPEG, PNG, WEBP, and PDF are allowed."
                                      );
                                      return Upload.LIST_IGNORE; // stops adding to list
                                    }

                                    // ✅ If allowed, store file in your state
                                    setReplyFilesMap((prev) => ({
                                      ...prev,
                                      [comment.commentId]: [
                                        ...(prev[comment.commentId] || []),
                                        file,
                                      ],
                                    }));

                                    return false;
                                  }}
                                >
                                  <Button>Choose files...</Button>
                                </Upload>
                              </span>
                              <p>Max total size: 500 kB</p>
                            </div>
                          </div>
                          {fileCommentError && (
                            <p
                              className="profile-file-error"
                              style={{ color: "red" }}
                            >
                              {fileCommentError}
                            </p>
                          )}
                        </div>
                        <div className="my-topics-reply">
                          <Button
                            className="main-fill-button"
                            onClick={() =>
                              submitReply({
                                type: "comment",
                                id: comment.commentId,
                                content: replyContents[comment.commentId],
                                files: replyFilesMap[comment.commentId] || [],
                              })
                            }
                          >
                            Submit reply
                          </Button>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Replies */}
              </div>
            </div>
          );
        })}

        {/* Your reply box */}
        <div className="topics-main-grid" ref={bottomReplyRef}>
          <div className="news-man-profile">
            <img src={UserImage} alt="you" />
            <h2>You</h2>
          </div>

          <div style={{ flex: 1 }} className="news-main-second-card">
            <div className="upload-button-topics">
              <TextArea
                placeholder="Write your reply..."
                rows={4}
                value={replyContent}
                style={{ marginBottom: 12 }}
                onChange={(e) => setReplyContent(e.target.value)}
              />
              <div className="custom-upload-menu_top">
                <img src={LinkOutImage} />
                <div className="custom-upload-menu">
                  <span>
                    Drag files here to attach, or
                    <Upload
                      className="multipal-image"
                      beforeUpload={(file) => {
                        const allowedTypes = [
                          "image/jpeg",
                          "image/jpg",
                          "image/png",
                          "image/webp",
                          "application/pdf",
                        ];

                        // Check file type
                        const isAllowed = allowedTypes.includes(file.type);

                        if (!isAllowed) {
                          // ❌ Show inline Ant Design error
                          setFileError(
                            "Invalid file type! Only JPG, JPEG, PNG, WEBP, and PDF are allowed."
                          );
                          return Upload.LIST_IGNORE; // stops adding to list
                        }

                        const isLt500KB = file.size / 1024 < 500;
                        if (!isLt500KB) {
                          setFileError(
                            "File size must be smaller than 500 KB!"
                          );
                          return Upload.LIST_IGNORE;
                        }

                        setReplyFiles((prev) => [...prev, file]);
                        return false;
                      }}
                    >
                      <Button className="ml-1">Choose files...</Button>
                    </Upload>
                  </span>
                  <p>Max total size: 500 kB</p>
                </div>
                {fileError && (
                  <p className="profile-file-error" style={{ color: "red" }}>
                    {fileError}
                  </p>
                )}
              </div>
            </div>
            <div className="my-topics-reply">
              <Button
                className="main-fill-button"
                onClick={() =>
                  submitReply({
                    type: "thread",
                    id: thread.threadId,
                    content: replyContent, // pass the bottom reply text
                    files: replyFiles, // pass the bottom reply files
                  })
                }
              >
                Submit reply
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Forum Modal */}
      <Modal
        open={isForumModalVisible}
        title="Select Forum"
        footer={null}
        width={385}
        onCancel={() => setIsForumModalVisible(false)}
        className="custom-modal"
        centered
      >
        <Select
          placeholder="Select Forum"
          style={{ width: "100%", marginBottom: 20 }}
          onChange={(value) => setSelectedForum(value)}
          className="custom-select"
        >
          {forums.map((forum) => (
            <Option key={forum._id} value={forum._id}>
              {forum.title}
            </Option>
          ))}
        </Select>
        <Button
          className="Fill-button"
          block
          onClick={handleForumContinue}
          disabled={!selectedForum}
        >
          Continue
        </Button>
      </Modal>

      {/* Topic Modal */}
      <Modal
        open={isTopicModalVisible}
        title="Create topic"
        width={877}
        footer={null}
        onCancel={() => setIsTopicModalVisible(false)}
        className="custom-modal"
        centered
      >
        <Input
          className="input-full"
          placeholder="Title"
          style={{ marginBottom: 12 }}
          value={topicTitle}
          onChange={(e) => setTopicTitle(e.target.value.replace(/^\s+/, ""))}
        />
        <div className="upload-button-topics">
          <TextArea
            placeholder="Description"
            rows={4}
            style={{ marginBottom: 12 }}
            value={topicDescription}
            onChange={(e) =>
              setTopicDescription(e.target.value.replace(/^\s+/, ""))
            }
          />
          <div className="topics-upload-button">
            <Upload
              // multiple
              fileList={files}
              beforeUpload={(file) => {
                setFiles((prev) => [...prev, file]);
                return false;
              }}
              onRemove={(file) => {
                setFiles((prev) => prev.filter((f) => f.uid !== file.uid));
              }}
            >
              <div className="topics-upload-box">
                <img src={LinkOutImage} />
                <div className="custom-upload-menu">
                  <span>
                    Drag files here to attach, or{" "}
                    <Button>Choose files...</Button>
                  </span>
                  <p>Max total size: 500 kB</p>
                </div>
              </div>
            </Upload>
          </div>
        </div>
        <p className="note-text">
          Your topic will need to be approved by a moderator.
        </p>
        <Button className="Fill-button" block onClick={handleTopicSubmit}>
          Submit topic
        </Button>
      </Modal>
      {/* Report Modal */}
      <ReportModal
        open={reportOpen}
        onClose={() => setReportOpen(false)}
        onSubmit={async (data) => {
          // send to API
          try {
            const message = data.reason;
            const response = await reportForum(commentId, message);

            console.log("API Response:", response);
            ShowToast("Report submitted successfully", Severty.SUCCESS);
            setReportOpen(false);
          } catch (error) {
            ShowToast(error.message, Severty.ERROR);
          }
        }}
      />
    </Main>
  );
};

export default FinalRoundNews;
